import useDictionary from 'lib/hooks/useDictionary';
import styles from './ProductDisclaimer.module.scss';

const DISCLAIMER_KEY = 'Components.Product.ProductDisclaimer.ProductDisclaimerText';

function shouldDisplayDisclaimer(text: string | undefined, key: string) {
  return !!text && text.trim() !== '' && text !== key;
}

export function ProductDisclaimer() {
  const { getDictionaryValue } = useDictionary();
  const productDisclaimerText = getDictionaryValue(DISCLAIMER_KEY);

  if (!shouldDisplayDisclaimer(productDisclaimerText, DISCLAIMER_KEY)) return null;

  return (
    <div className={styles.productDisclaimer}>
      <p className={styles.productDisclaimerText}>{productDisclaimerText}</p>
    </div>
  );
}
